import { LOCALE_CONFIG } from '../../configs'

export const currencyFormatter = new Intl.NumberFormat(LOCALE_CONFIG.default, { style: 'currency', currency: 'EUR' })
